import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_call_full",
  "use": "icon-i_call_full-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_call_full\"><title>icon_画板</title><path d=\"M20,22.41l.76-.47a7.15,7.15,0,0,1,.79-.43c1.73-.79,3.25-.23,5.27,2.12,1.24,1.46,1.61,2.76,1.13,3.91a4.89,4.89,0,0,1-2.28,2.19l-1,.57C21.8,32.07,15.23,28,10.51,21.11S4.56,6.79,7.46,5l.38-.24.42-.27c1.46-1,2.4-1.33,3.52-1.14a4.23,4.23,0,0,1,2.86,2.51c1.68,3.17,1.31,4.67-.86,6l-.76.47c-.53.33.37,2.53,2.46,5.6s3.89,4.79,4.47,4.44Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol